import React from 'react';

const VMK_TEAL = '#179f9f';

const iconProps = {
  className: 'vmk-process-step-icon',
  width: 28,
  height: 28,
  viewBox: '0 0 28 28',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
  'aria-hidden': true,
};

const s = {
  stroke: VMK_TEAL,
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const VmkProcessQuoteIcon = () => (
  <svg {...iconProps}>
    <path d="M5 12.5 14 5l9 7.5V22a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V12.5z" {...s} />
    <path d="M11 23v-7h6v7" {...s} />
    <path d="M17.5 12.5 14 15l-2-2" {...s} />
  </svg>
);

export const VmkProcessSurveyIcon = () => (
  <svg {...iconProps}>
    <rect x="6" y="5" width="16" height="18" rx="1.5" {...s} />
    <path d="M10 10h8M10 14h8M10 18h5" {...s} />
    <path d="M19 19l3.5 3.5" {...s} />
    <circle cx="20.5" cy="20.5" r="2.5" {...s} />
  </svg>
);

export const VmkProcessFactoryIcon = () => (
  <svg {...iconProps}>
    <path d="M5 22V11l6-4 5 3.5V22" {...s} />
    <path d="M16 22V14l7-4.5V22" {...s} />
    <path d="M9 22v-6h4v6" {...s} />
    <path d="M4 10l4-2.5M24 10l-4-2.5" {...s} />
  </svg>
);

export const VmkProcessDeliveryIcon = () => (
  <svg {...iconProps}>
    <path d="M4 16h15l3-6V8H4v8z" {...s} />
    <circle cx="9" cy="19" r="2" {...s} />
    <circle cx="18" cy="19" r="2" {...s} />
    <path d="M19 12h4l2.5 4.5V16H19" {...s} />
  </svg>
);

export const VmkProcessInstallIcon = () => (
  <svg {...iconProps}>
    <path d="M8 20l6-10 6 10" {...s} />
    <path d="M11 16h6" {...s} />
    <path d="M14 6v5" {...s} />
    <path d="M11.5 9.5h5" {...s} />
  </svg>
);

export const VmkProcessHandoverIcon = () => (
  <svg {...iconProps}>
    <path d="M14 5.5 21 9v6.5c0 5-3.5 8-7 9-3.5-1-7-4-7-9V9l7-3.5z" {...s} />
    <path d="M10.5 14.5 13 17l5-5.5" {...s} />
  </svg>
);

export const VMK_PROCESS_STEP_ICONS = [
  VmkProcessQuoteIcon,
  VmkProcessSurveyIcon,
  VmkProcessFactoryIcon,
  VmkProcessDeliveryIcon,
  VmkProcessInstallIcon,
  VmkProcessHandoverIcon,
];
